import { runestone_import } from "../../../webpack.index.js";
import { getDataValue } from "./domutil.js";

export async function renderRunestoneComponent(
    componentSrc,
    whereDiv,
    moreOpts,
) {
    /**
     *  The easy part is adding the componentSrc to the existing div.
     *  The tedious part is calling the right functions to turn the
     *  source into the actual component.
     */
    let target = document.getElementById(whereDiv);
    if (!target) {
        return;
    }
    if (!componentSrc) {
        target.innerHTML = `<p>Sorry, no source is available for preview.</p>`;
        return;
    }
    let patt = /..\/_images/g;
    componentSrc = componentSrc.replace(
        patt,
        `${eBookConfig.app}/books/published/${eBookConfig.basecourse}/_images`,
    );
    target.innerHTML = componentSrc;

    if (typeof window.componentMap === "undefined") {
        window.componentMap = {};
    }

    let componentElement = target.querySelector("[data-component]");
    let componentKind = componentElement?.dataset.component;
    // Import the JavaScript for this component before proceeding.
    await runestone_import(componentKind);
    let opt = {};
    opt.orig = componentElement;
    if (opt.orig) {
        opt.lang = getDataValue(opt.orig, "lang");
        opt.useRunestoneServices = true;
        opt.graderactive = false;
        opt.python3 = true;
        if (typeof moreOpts !== "undefined") {
            for (let key in moreOpts) {
                opt[key] = moreOpts[key];
            }
        }
    }

    if (typeof component_factory === "undefined") {
        alert("Error:  Missing the component factory!");
    } else {
        if (!window.component_factory[componentKind] && !target.innerHTML) {
            target.innerHTML = `<p>Preview not available for ${componentKind}</p>`;
        } else {
            let res = window.component_factory[componentKind](opt);
            if (componentKind === "activecode") {
                if (moreOpts.multiGrader) {
                    window.componentMap[
                        `${moreOpts.gradingContainer} ${res.divid}`
                    ] = res;
                } else {
                    window.componentMap[res.divid] = res;
                }
            }
        }
    }
}

export function createTimedComponent(componentSrc, moreOpts) {
    /* The important distinction is that the component does not really need to be rendered
    into the page, in fact, due to the async nature of getting the source the list of questions
    is made and the original html is replaced by the look of the exam.
    */

    let patt = /..\/_images/g;
    componentSrc = componentSrc.replace(
        patt,
        `${eBookConfig.app}/books/published/${eBookConfig.basecourse}/_images`,
    );

    let parsed = document.createElement("div");
    parsed.innerHTML = componentSrc;
    let componentElement = parsed.querySelector("[data-component]");
    let componentKind = componentElement?.dataset.component;
    let origId = componentElement?.getAttribute("id");

    // Double check -- if the component source is not in the DOM, then briefly add it
    // and call the constructor.
    if (!document.getElementById(origId)) {
        let hdiv = document.createElement("div");
        hdiv.style.display = "none";
        hdiv.innerHTML = componentSrc;
        document.body.appendChild(hdiv);
    }

    let ret;
    let opts = {
        orig: document.getElementById(origId),
        timed: true,
    };
    if (typeof moreOpts !== "undefined") {
        for (let key in moreOpts) {
            opts[key] = moreOpts[key];
        }
    }

    if (componentKind in window.component_factory) {
        ret = window.component_factory[componentKind](opts);
    }

    let rdict = {};
    rdict.question = ret;
    return rdict;
}

// For integration with the React overhault of Pretext
// 1. Disable the automatic instantiation at the end of each component.js
// 2. react will search for all ".runestone" and will call this function for each of them.
export async function renderOneComponent(rsDiv) {
    // Find the actual component inside the runestone component.
    let component = rsDiv.querySelector("[data-component]");
    if (component == null) {
        console.log(
            "Render was called for a component, but now [data-component] attribute is present. This may mean the component has already been rendered.",
        );
        return;
    }
    let componentKind = component.dataset.component;
    await runestone_import(componentKind);
    if (!rsDiv.closest("[data-component=timedAssessment]")) {
        // If this element exists within a timed component, don't render it here
        try {
            let divid = component.id;
            window.componentMap[divid] = window.component_factory[
                componentKind
            ]({
                orig: component,
                useRunestoneServices: eBookConfig.useRunestoneServices,
            });
        } catch (err) {
            console.log(`Error rendering ${componentKind} Problem ${component.id}
                         Details: ${err}`);
        }
    }
}
